import { getPropertyValue } from '@fourthwall/utils/dist/styles';
export const getStripeCardStyle = () => {
    const fontSize = getPropertyValue('--font-size-400');
    const primaryColor = getPropertyValue('--text-primary');
    const secondaryColor = getPropertyValue('--text-secondary');
    const fontFamily = getPropertyValue('--font-family-body');
    return {
        base: {
            fontSize,
            color: primaryColor,
            lineHeight: '24px',
            fontSmoothing: 'antialiased',
            fontFamily,
            backgroundColor: 'transparent',
            ':-webkit-autofill': {
                color: primaryColor,
            },
            '::placeholder': {
                color: secondaryColor,
            },
        },
        invalid: {
            color: primaryColor,
        },
    };
};
